import { createFileRoute } from '@tanstack/react-router'
import { LoginPage } from '~/features/auth/pages/login';
import { LoginSearchParams } from '~/features/auth/types';

export const Route = createFileRoute('/(auth)/_auth/urgent-care')({
  component: () => <LoginPage />,
  validateSearch: (search: Record<string, unknown>): LoginSearchParams => {
    return {
      redirect: search.redirect as string | undefined,
      email: search.email as string | undefined,
      status: search.status as "success" | undefined,
    };
  },

  errorComponent: ({ error }: { error: Error }) => (
    <div role="alert" className="flex min-h-screen w-full items-center justify-center p-4">
      <div className="text-center">
        <h1 className="text-2xl font-bold">Signin Error</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
})
